//---------------------------
// is ability characteristic
//---------------------------
export default function isAbilityCharacteristic(pfx) {
  let char_array = ['str', 'dex', 'siz', 'pow','int']

  if (char_array.includes(pfx)) return true
  else return false
}
